import PropTypes from 'prop-types';
import ButtonSwitcher from '../../../../../../../../common/Switcher';
import {useEffect} from 'react';

const ValueTypeSwitcher = ({
	activeOptionKey,
	onActiveOptionChange,
	onMount,
}) => {
	useEffect(() => {
		if (onMount && typeof onMount === 'function') {
			onMount();
		}
	}, []);

	return (
		<ButtonSwitcher
			condensed
			icon="ri-bar-line-chart"
			activeOptionKey={activeOptionKey}
			options={[
				{key: 'measured', data: {nameDisplay: 'Measured'}},
				{key: 'average', data: {nameDisplay: 'Average'}},
			]}
			onActiveOptionChange={onActiveOptionChange}
		/>
	);
};

ValueTypeSwitcher.propTypes = {
	activeOptionKey: PropTypes.string,
	onActiveOptionChange: PropTypes.func,
	onMount: PropTypes.func,
};

export default ValueTypeSwitcher;
